export const TRACKING_EVENTS = {
  jobApplication: "job_application",
};